import { updateCustomerById } from "../../../app/api/updateCustomerById";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFmlmFavouriteLocationAtom } from "../../../Orchestrator/Recoils/LocationAtom";
import { IFmlmMile, IUserResponse } from "../../../Orchestrator/Types/Index";
import { IFavoriteFmlmLocationActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/FavouriteFmlmLocationActionParams";
import { showNotification } from "../../../Services/notificationService";
import { getFmlmFavouritesFromLocalStorage, saveFmlmFavouritesToLocalStorage } from "../FmlmSearch/SaveFmlmFavouritesToLocalStorageAction";
import { invalidateUserCaches } from "../../LogicActions/MyAccount/invalidateUserCaches";

const DEFAULT_FMLM_MILE: IFmlmMile = {
  latitude: 0,
  longitude: 0,
  name: ""
}

export const isValidFmlmMile = (fmlm: IFmlmMile): boolean => {
  if (fmlm && fmlm.latitude && fmlm.longitude && fmlm.name) return true;
  return false;
}

class FavouriteFmlmLocationAction extends BaseAction<IUserResponse, IFavoriteFmlmLocationActionParams> {
  override async run(): Promise<IUserResponse | null> {
    let userResponse: IUserResponse | null = null;

    try {
      this.params?.locationState
      const { locationState, userData, selectedExactLocation, intl } = this.params!;

      let newMile: IFmlmMile | null = null;
      if (locationState) {
        newMile = {
          latitude: locationState.coordinates[1],
          longitude: locationState.coordinates[0],
          name: locationState.name
        }
      }

      if (!userData?.id) {
        let fmlmOriginFavouriteLoation = await getFmlmFavouritesFromLocalStorage("origin")
        let fmlmDestinationFavouriteLoation = await getFmlmFavouritesFromLocalStorage("destination")

        let data: IFmlmFavouriteLocationAtom = {
          "firstMile": fmlmOriginFavouriteLoation || DEFAULT_FMLM_MILE,
          "lastMile": fmlmDestinationFavouriteLoation || DEFAULT_FMLM_MILE
        }

        if (selectedExactLocation === "origin") {
          data.firstMile = newMile || DEFAULT_FMLM_MILE
        } else if (selectedExactLocation === "destination") {
          data.lastMile = newMile || DEFAULT_FMLM_MILE
        }

        updateRecoilState<IFmlmFavouriteLocationAtom>("fmlmFavouriteLocationAtom", data)
        saveFmlmFavouritesToLocalStorage.setParams({
          selectedExactLocation: selectedExactLocation as "origin" | "destination",
          fmlmMile: newMile || undefined
        });
        await saveFmlmFavouritesToLocalStorage.execute();

        if (locationState && newMile) {
          showNotification("success", intl.formatMessage({ id: "addedToYourFavorites" }), "");
        } else {
          showNotification("success", intl.formatMessage({ id: "removedFromYourFavorites" }), "");
        }

        return userData;
      } else {
        let firstAndLastMilePayload: NonNullable<IUserResponse['railPreferences']>['firstAndLastMile'] = userData?.railPreferences?.firstAndLastMile;

        if (locationState && newMile) {
          if (!firstAndLastMilePayload) {
            firstAndLastMilePayload = {
              firstMile: DEFAULT_FMLM_MILE,
              lastMile: DEFAULT_FMLM_MILE
            }
          }

          if (selectedExactLocation === "origin") {
            firstAndLastMilePayload = {
              ...firstAndLastMilePayload,
              firstMile: newMile
            };
          } else if (selectedExactLocation === "destination") {
            firstAndLastMilePayload = {
              ...firstAndLastMilePayload,
              lastMile: newMile
            };
          }

          if (!isValidFmlmMile(firstAndLastMilePayload.firstMile)) {
            firstAndLastMilePayload.firstMile = DEFAULT_FMLM_MILE;
          }
          if (!isValidFmlmMile(firstAndLastMilePayload.lastMile)) {
            firstAndLastMilePayload.lastMile = DEFAULT_FMLM_MILE;
          }
        } else {
          if (selectedExactLocation === "origin") {
            firstAndLastMilePayload = {
              firstMile: DEFAULT_FMLM_MILE,
              lastMile: firstAndLastMilePayload?.lastMile || DEFAULT_FMLM_MILE
            };
          }
          else if (selectedExactLocation === "destination") {
            firstAndLastMilePayload = {
              firstMile: firstAndLastMilePayload?.firstMile || DEFAULT_FMLM_MILE,
              lastMile: DEFAULT_FMLM_MILE
            };
          }
        }

        const response = await updateCustomerById(userData.id.toString(), {
          railPreferences: {
            ...(userData.railPreferences || {}),
            firstAndLastMile: firstAndLastMilePayload,
          },
        });

        if (response.status === "ok" && response.answer) {
          if (firstAndLastMilePayload) {
            updateRecoilState<IFmlmFavouriteLocationAtom>("fmlmFavouriteLocationAtom", firstAndLastMilePayload);
          }

          if (locationState && newMile) {
            showNotification("success", intl.formatMessage({ id: "addedToYourFavorites" }), "");
          } else {
            showNotification("success", intl.formatMessage({ id: "removedFromYourFavorites" }), "");
          }
          userResponse = response.answer;
          updateRecoilState("userDataAtom", response.answer);
          invalidateUserCaches();
        } else {
          console.warn("Failed to save favourite FMLM location.");
        }
      }
    } catch (error) {
      console.error("Error in FavouriteFmlmLocationAction:", error);
    } finally {
      return userResponse
    }
  }
}

export const favouriteFmlmLocationAction = new FavouriteFmlmLocationAction();
